<script lang="ts" setup>
import { onMounted, watch } from "vue";
import { EditorContent } from "@tiptap/vue-3";
import { JSONContent } from "@tiptap/core";
import { useStory } from "@/stores/story";
import { Story } from "@/types/entity";
import editorUtils from "@/modules/editor/editor-utils";

// props
const props = defineProps<{
  story: Story;
  reserveParagraphCount?: number;
}>();
// State
const storyStore = useStory();
const editorInstance = editorUtils.useStoryEditor({
  editable: false,
  content: "",
});
// Lifecycle
const truncateText = (json: JSONContent, maxTextLength: number) => {
  // 1. 深度优先遍历JSON，对于每个节点，如果是text类型，累计长度，如果超过maxTextLength，截断
  let currentLength = 0;
  let newJson = JSON.parse(JSON.stringify(json));
  const dfs = (json: JSONContent): boolean => {
    if (currentLength >= maxTextLength) {
      return false;
    }
    if (json.type === "text" && json.text) {
      currentLength += json.text.length;
      if (currentLength > maxTextLength) {
        json.text = json.text.slice(0, maxTextLength - currentLength) + "...";
        return false;
      }
    }
    if (json.content) {
      const newJsonContent = [];
      for (const item of json.content) {
        newJsonContent.push(item);
        if (!dfs(item)) {
          json.content = newJsonContent;
          return false;
        }
      }
    }
    return true;
  };
  dfs(newJson);
  return newJson;
};
onMounted(() => {
  const json = storyStore.getJson(props.story.text);
  if (!props.reserveParagraphCount) {
    editorInstance.value!.commands.setContent(json);
  } else {
    editorInstance.value!.commands.setContent(
      editorUtils.sliceByParagraph(json, props.reserveParagraphCount)
    );
  }
});
watch(
  () => props.story,
  () => {
    const json = storyStore.getJson(props.story.text);
    if (!props.reserveParagraphCount) {
      editorInstance.value!.commands.setContent(json);
    }
    if (props.reserveParagraphCount) {
      editorInstance.value!.commands.setContent(
        editorUtils.sliceByParagraph(json, props.reserveParagraphCount)
      );
    }
  }
);
</script>
<template>
  <editor-content :editor="editorInstance!" class="story-view" />
</template>
<style>
.story-view .tiptap {
  padding-bottom: 40px;
}

.story-view .story-image img {
  @apply max-h-[500px];
}
</style>
